<template>
  <div class="GoodsCheck">
    <div class="">
      <div style="line-height: 30px">
        <b class="colBlack"
          >Which of the following items does your shipment contain?</b
        >
        <span
          v-show="typeCargo.cargoIDs.length === 0"
          class="font12 marL20 colRed"
          >Please indicate which of the items listed below are included in your
          shipment.</span
        >
      </div>
      <ul>
        <el-checkbox-group v-model="typeCargo.cargoIDs">
          <li class="cargoli" v-for="(cargoItem, i) in list" :key="i">
            <el-checkbox
              class="font12"
              v-for="(item, j) in cargoItem"
              :key="j"
              :label="item.Id"
              @change="goodsId(item)"
            >
              <span class="hint tipsText marR5">
                <span class="font12">{{ item.otherEn }}</span>
                <div
                  v-show="item.RemarkEn"
                  class="floTipBox"
                  style="white-space: normal; right: 0; left: 0"
                >
                  <i style="right: 75%"></i>
                  <p>{{ item.RemarkEn }}</p>
                </div>
              </span>
            </el-checkbox>
          </li>
          <li v-if="isSHRshow">
            <b class="font12 colBlack">
              Is there any appraisal report from Shanghai Research institute of
              Chemical industry (SRICI)
            </b>
            <el-radio
              v-model="typeCargo.isSHReport"
              :label="true"
              style="margin: 0 50px 0 20px"
              ><span :class="{ colRed: typeCargo.isSHReport === '' }">Yes</span>
            </el-radio>
            <el-radio v-model="typeCargo.isSHReport" :label="false"
              ><span :class="{ colRed: typeCargo.isSHReport === '' }">No</span>
            </el-radio>
            <p style="margin: 10px 0">
              <span class="dataTip colRed font12">
                <i
                  class="fa fa-tips2 font14 colRed"
                  style="margin-top: -3px"
                ></i>
                For the goods with battery takeing off from Shanghai, the
                Shipper is required to provide theappraisal report from Shanghai
                Research institute of Chemical industry (SRICI).
              </span>
            </p>
          </li>
        </el-checkbox-group>
      </ul>
    </div>
  </div>
</template>
<script>
import { post, fetch, Del, put } from "@/ask/axios";
export default {
  props: {
    isSHRshow: { type: Boolean },
    value: { type: Object },
    list: { type: Array },
  },

  model: {
    prop: "value",
    event: "sendGoods",
  },

  data() {
    return {
      typeCargo: {
        isSHReport: "",
        cargoIDs: [],
      },
      cargoList: [],
    };
  },
  created() {
    this.typeCargo.cargoIDs = [Number(this.$route.query.cargoId)];
    this.typeCargo.isSHReport =
      this.$route.query.IsSHReport === null
        ? ""
        : ( this.$route.query.IsSHReport === 0 ? false : true);
  },
  watch: {
    // 将值传给v-model
    typeCargo: {
      deep: true,
      handler: function (newV, oldV) {
        this.$emit("sendGoods", this.typeCargo);
      },
    },
  },

  methods: {
    goodsId(item) {
      //判断之间的排斥关系
      let generalCargoID = sysCfg.air.Cargo.generalCargoID; // 普货 ID
      let porCargoID = sysCfg.air.Cargo.porCargoID; // 移动电源ID
      let batteryCargoID = sysCfg.air.Cargo.batteryCargoID; // 纯电池ID
      if (
        item.Id === generalCargoID ||
        item.Id === porCargoID ||
        item.Id === batteryCargoID
      ) {
        this.typeCargo.cargoIDs.forEach((e) => {
          if (item.Id == e) {
            this.typeCargo.cargoIDs = [e];
          }
        });
      } else {
        if (
          JSON.stringify(this.typeCargo.cargoIDs) ==
            JSON.stringify([generalCargoID, item.Id]) ||
          JSON.stringify(this.typeCargo.cargoIDs) ==
            JSON.stringify([porCargoID, item.Id]) ||
          JSON.stringify(this.typeCargo.cargoIDs) ==
            JSON.stringify([batteryCargoID, item.Id])
        ) {
          this.typeCargo.cargoIDs = [item.Id];
        }
      }
    },
  },
};
</script>
<style scoped>
.cargoli {
  height: 30px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/reception/air/query/typesOfGoods.vue